import { useDataTableContext } from "pages/gdt/store/DataTableProvider";
import { useState } from "react";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import { addUtilityToastSuccess } from "utils/addUtilityToastSuccess";
import { DATA_TABLE_TOOLTIP_ID } from "../DataTableTooltip";
import { ButtonIconPlainPermissioned } from "pages/gdt/plain/ButtonIconPlain";

interface QuickActionCopyRowBaseProps {
  tableId: string;
  rowIds: string[];
  tooltipContent: string;
  isDisabled: boolean;
  id: string;
}

const QuickActionCopyRowBase = ({
  tableId,
  rowIds,
  tooltipContent,
  isDisabled,
  id,
}: QuickActionCopyRowBaseProps) => {
  const copyRow = useDataTableContext((s) => s.copyAnalysisTableRow);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    const { error } = await copyRow({ tableId, rowId: rowIds[0] });
    setIsLoading(false);
    if (error === undefined) {
      addUtilityToastSuccess("Row(s) copied");
    } else {
      addUtilityToastFailure("Failed to copy row(s)");
    }
  };

  return (
    <ButtonIconPlainPermissioned
      requiredPermission="edit"
      aria-label={tooltipContent}
      data-tooltip-id={DATA_TABLE_TOOLTIP_ID}
      data-tooltip-content={tooltipContent}
      color="primary"
      iconSize="m"
      iconType="copy"
      onClick={() => void handleClick()}
      disabled={isDisabled}
      isLoading={isLoading}
      id={id}
    />
  );
};

interface QuickActionCopyRowProps {
  tableId: string;
  rowId: string;
  readOnly?: boolean;
}

export const QuickActionCopyRow = ({
  tableId,
  rowId,
  readOnly,
}: QuickActionCopyRowProps) => {
  return (
    <QuickActionCopyRowBase
      tooltipContent="Copy row"
      tableId={tableId}
      rowIds={[rowId]}
      isDisabled={readOnly ?? false}
      id={"quickActionCopyRow"}
    />
  );
};
export interface QuickActionCopySelectedRowsProps {
  selectedRowIds: string[];
  tableId: string;
}
export const QuickActionCopySelectedRows = ({
  selectedRowIds,
  tableId,
}: QuickActionCopySelectedRowsProps) => {
  return (
    <QuickActionCopyRowBase
      tooltipContent="Copy selected rows"
      tableId={tableId}
      rowIds={selectedRowIds}
      isDisabled={selectedRowIds.length === 0}
      id={"quickActionCopySelectedRows"}
    />
  );
};
